import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_evs5oljf5i: FaireBrandEntity = {
  token: "b_evs5oljf5i",
  type: "brand",
  name: "Suzie Q USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/9c3f967a7746e5484959341f5a420e5786bb86014bed4d4bc56f9bcf68708c0f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1637ea30a607b8a9cb5b243952cd9bf6d89b9c93c40909502fd331ec97e18a2d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9c3f967a7746e5484959341f5a420e5786bb86014bed4d4bc56f9bcf68708c0f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1637ea30a607b8a9cb5b243952cd9bf6d89b9c93c40909502fd331ec97e18a2d.png",
  location: "DALLAS, TX, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 1319,
  isTopShop: true,
  isInsider: true,
  description:
    "Suzie Q USA family is all about the latest designs and trends. We are the provider of endless collection from modern to classical designs of hats, jewelries, appeals, general merchandise and many more to over five thousand successful retailers throughout the USA. Suzie Q USA is a trusted name with an exceptional delivery and handling services. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:49.286Z",
    importedBy: "entity-db-cli",
  },
};
